import { FeatureKey } from 'src/app/_models';
import { RiskanalysisService } from './../services/risk-analysis.service';
import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SelectItem, ConfirmationService } from 'primeng/api';
import { IMyDpOptions } from 'mydatepicker';
import * as _ from 'lodash';

import { Feature, Rights, SessionFeature } from './../../../_models/feature';
import { ToasterComponent } from 'src/app/_directives/toaster.component';
import { DeviationList } from '../../deviation/models/deviationList';
import { TypeOfCase, Topic } from './../models/deviation';
import { DeviationServices } from '../services/deviation.services';
import { HelperService } from 'src/app/_services/helper.service';
import { BaseServices } from 'src/app/kuba/kuba.services';
import { ValidationService } from 'src/app/kuba/shared/services/validation.service';
import { TranslateService } from '@ngx-translate/core';
import { EmployeeServices } from '../../employees/services/employee.services';
import { Table } from 'primeng/table';
import { Observable, Subscription } from 'rxjs';
import { FeaturesBaseServices } from '../../features/services/features-base.services';
import { DeviationListChartsComponent } from './deviation-list-charts/deviation-list-charts.component';
import { Dropdown } from 'primeng/dropdown';
import { DeviationFilterDto } from '../models/deviationFilterRequest';
import { PagedResponse } from '../../shared/models/pagedResponse';
import { PaginationRequest } from '../../shared/models/paginationRequest';
import { DeviationListDto } from '../models/deviationListDto';
import { DeviationListMetadata } from '../models/deviationListMetaData';

interface DropdownEvent {
  value: string | null;
}

// Updated PaginationRequest interface with sorting support
export interface PaginationRequestClass extends PaginationRequest {
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

@Component({
  selector: 'deviationList',
  templateUrl: 'deviation-list.component.html',
  styleUrls: ['deviation-list.component.scss'],
})
export class DeviationListComponent implements OnInit, OnDestroy {
  //#region variables
  vDepartment: SelectItem[];
  departmentIds: number[] = [];
  vModules: SelectItem[];
  showDeviationDrop: boolean = false;
  showDeviationDisabled: boolean = false;

  filteredFollowUpPersons: any[] = [];
  filteredExecutionPersons: any[] = [];
  selectedFollowUpPerson: any = null;
  selectedExecutionPerson: any = null;

  @ViewChild(ToasterComponent, { static: false })
  toasterComponent: ToasterComponent;
  @ViewChild('deviationTable', { static: false }) deviationTable: Table;

  paginationRequest: PaginationRequestClass = {
    pageNumber: 1,
    pageSize: 10,
    sortColumn: undefined,
    sortDirection: 'ASC'
  };

  private columnMapping: { [key: string]: string } = {
    'No': 'No',
    'BusinessName': 'BusinessName',
    'Title': 'Title',
    'CreatedOn': 'CreatedOn',
    'CompletedDate': 'DoneOn',
    'DeadlineForPdf': 'CreatedOn',
    'ChecklistName': 'Title',
    'ActivityName': 'Title',
    'Modules': 'Title',
    'Cost': 'Title'
  };

  totalPages: number = 0;

  deviationFilterDto: DeviationFilterDto = {};
  public deviationList: DeviationListDto[];
  public deviationAllList: DeviationList[];

  public isLoadingData: boolean = false;
  private loadingSubscription: Subscription;
  public applicationId: number = BaseServices.ApplicationId;
  public portalId: number = 0;

  statuses: SelectItem[];
  Case: SelectItem[];
  Client: SelectItem[];
  ShowDeviation: SelectItem[];
  status: SelectItem[];
  followup: any[];
  Topics: SelectItem[];
  topicForm: FormGroup;
  deviationSearch: FormGroup;
  caseForm: FormGroup;
  businesses: any[];
  editTopics: any = [];
  editTypeOfCases: any = [];
  startDate: string;
  endDate: string;
  isStatusDone = false;
  isEditor: boolean;
  isAdmin: boolean;
  isPortal: boolean;
  itemsPerPage = 10;
  pageSum = 0;
  topicId: number;
  caseId: number;
  viewTopic = false;
  addtypeOfCase = false;
  viewTypeOfCase = false;
  addTopic = false;
  isShowDeptDeviation = false;
  isShowSaveButton = true;
  newButtonDisplay = true;
  userId: number;
  hasDeviationDeleteAccess = true;
  userRole: string;
  additionalData: any;
  isNameExists: boolean;
  existsAlerttext: string;
  departments: any;
  subDepartments: any;
  isTopicNameExists: boolean;
  existsTopicAlerttext: string;
  existsTypeCaseAlerttext: string;
  isTypeCaseNameExists: boolean;
  importances: any;
  totalRecords: number;
  isShowPlusbutton = true;
  createdBy: SelectItem[];
  showLoader = true;
  currentDeviation: any;
  loading = false;
  isBusinessId = false;
  isShowNewButton = false;
  rowsPerPageOptions: any = [];
  vresperson = [];
  Showloader: boolean;
  departmentList: any[];
  displayDeviation = false;
  deptFilter: any = null;
  clientFilter: any = null;
  createdToFilter: any = null;
  craetedFromFilter: any = null;
  descFilter: any = null;
  responsibleFollowUpFilter: any = null;
  responsibleExecutionFilter: any = null;
  createdByFilter: any = null;
  businessFeature: Feature[];
  chartViews: string[] = ['chartType1', 'chartType2', 'chartType3'];
  currentIndex: number = 0;
  isPaused: boolean = false;

  noFilter: string = '';
  businessNameFilter: string = '';
  titleFilter: string = '';
  checklistNameFilter: string = '';
  activityNameFilter: string = '';

  private filterDebounceTimer: any;

  selectedFilters: {
    topic: string | null;
    case: string | null;
    followUp: string | null;
    execution: string | null;
    department: string | null;
    subDepartment: string | null;
  } = {
    topic: null,
    case: null,
    followUp: null,
    execution: null,
    department: null,
    subDepartment: null,
  };

  deviationListMetadata : DeviationListMetadata;

  @ViewChild(DeviationListChartsComponent)
  chartsComponent: DeviationListChartsComponent;
  public startDateOptions: IMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    editableDateField: false,
    openSelectorOnInputClick: true,
    firstDayOfWeek: 'su',
    satHighlight: true,
    selectionTxtFontSize: '14px',
    height: '32px',
    todayBtnTxt: this.translate.instant('TODAY'),
    dayLabels: {
      su: this.translate.instant('SUN'),
      mo: this.translate.instant('MON'),
      tu: this.translate.instant('TUE'),
      we: this.translate.instant('WED'),
      th: this.translate.instant('THU'),
      fr: this.translate.instant('FRI'),
      sa: this.translate.instant('SAT'),
    },
    monthLabels: {
      1: this.translate.instant('JANUARY'),
      2: this.translate.instant('FEBRUARY'),
      3: this.translate.instant('MARCH'),
      4: this.translate.instant('APRIL'),
      5: this.translate.instant('MAY'),
      6: this.translate.instant('JUNE'),
      7: this.translate.instant('JULY'),
      8: this.translate.instant('AUGUST'),
      9: this.translate.instant('SEPTEMBER'),
      10: this.translate.instant('OCTOBER'),
      11: this.translate.instant('NOVEMBER'),
      12: this.translate.instant('DECEMBER'),
    },
  };

  public endDateOptions: IMyDpOptions = this.startDateOptions;
  private subscriptions: Subscription[] = [];
  isIKdeviation: boolean = false;
  isAHdeviation: boolean = false;
  isInternalControl: boolean = false;
  isproject: boolean = false;
  isothersystem: boolean = false;
  isqualitysystem: boolean = false;
  isfdv: boolean = false;
  isVehicles: boolean = false;
  isFoodSafety: boolean = false;
  isKubaControl: boolean = false;
  isFramework: boolean = false;
  isService: boolean = false;
  isKunde: boolean = false;
  features: SessionFeature[];
  isDeptSelected: boolean = false;

  private paginationDebounceTimerId: any = null;
  private readonly PAGINATION_DEBOUNCE_TIME_MS = 300;

  /**
   * constructor
   * @param deviationService {DeviationService}
   * @param route {ActivatedRoute}
   * @param confirmationService {ConfirmationService}
   */
  constructor(
    private deviationService: DeviationServices,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private _fb: FormBuilder,
    private riskanalysisService: RiskanalysisService,
    private translate: TranslateService,
    private employeeServices: EmployeeServices
  ) {
    this.topicForm = this._fb.group({
      Topic: [
        '',
        [Validators.required, ValidationService.noWhitespaceValidator],
      ],
    });
    this.caseForm = this._fb.group({
      Case: [
        '',
        [Validators.required, ValidationService.noWhitespaceValidator],
      ],
    });
    this.deviationSearch = this._fb.group({
      topic: [''],
      typeOfCase: [],
    });
    this.userId = BaseServices.UserId;
    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe((val) => {
        this.additionalData = {
          fileName: val.DEVIATION_LIST,
          header: this.translate.instant('DEVIATION_LIST'),
          businessId: BaseServices.BusinessId,
          cultureInfo: BaseServices.userCultureInfo(),
          columnNames: [
            { title: 'Deviation Number', dataKey: 'No' },
            { title: 'Title', dataKey: 'Title' },
            { title: 'Checklist Name', datakey: 'ChecklistName' },
            { title: 'Status', dataKey: 'Status' },
            { title: 'Department', dataKey: 'Department' },
            { title: 'SubDepartment', dataKey: 'SubDepartment' },
            { title: 'Topics', datakey: 'TopicName' },
            { title: 'Type of Case', datakey: 'CaseName' },
            { title: 'Deadline', dataKey: 'DeadlineForPdf' },
            {
              title: 'Responsible for Execution',
              dataKey: 'ResponsiblePerson',
            },
            { title: 'Importance', dataKey: 'Importance.value' },
            { title: 'Description', dataKey: 'Description' },
            { title: 'Modules', dataKey: 'Modules' },
            { title: 'DisplayCost', dataKey: 'Cost' },
            { title: 'DisplayCost', dataKey: 'DisplayCost' },
            { title: 'Event Location', dataKey: 'EventLocation' },
            { title: 'Business', dataKey: 'BusinessName' },
            { title: 'Done On', dataKey: 'CompletedDateForPdf' },
            { title: 'Created On', dataKey: 'CreatedOn' },
            { title: 'Created By', dataKey: 'CreatorName' },
          ],
        };
      })
    );
  }

  //#endregion

  //#region page-events
  /**
   * bind list with status icon
   */
  ngOnInit(): void {
    document.querySelector('body').classList.remove('opened');
    this.currentDeviation = 1;
    this.userRole = BaseServices.UserRole;
    this.newButtonDisplay =
      BaseServices.roleId === '1'
        ? false
        : BaseServices.roleId === '2'
          ? false
          : true;
    this.isShowNewButton =
      BaseServices.roleId === '1'
        ? false
        : BaseServices.roleId === '2'
          ? false
          : true;
    this.isAdmin = BaseServices.roleId === '1' ? true : false;
    this.isPortal = BaseServices.roleId === '2' ? true : false;
    this.isEditor = BaseServices.roleId === '3' ? true : false;

    if (BaseServices.UserRole === 'User' || BaseServices.UserRole === 'Guest') {
      this.onAdministrateDeviation();
    } else {
      this.bindDeviationList(true);
    }

    if (window.name === 'Remote') {
      this.subscriptions.push(
        this.deviationService.getRModeFeature().subscribe((feature: any) => {
          if (feature) {
            this.businessFeature = <Feature[]>JSON.parse(feature.Features);
            var internal = this.businessFeature.filter(
              (x) => x.name === 'Internalcontrol' && x.checked === true
            );
            var project = this.businessFeature.filter(
              (x) => x.name === 'Project' && x.checked === true
            );
            var othersystem = this.businessFeature.filter(
              (x) => x.name === 'OtherSystems' && x.checked === true
            );
            var qualitysystem = this.businessFeature.filter(
              (x) => x.name === 'QualitySystem' && x.checked === true
            );
            var fdv = this.businessFeature.filter(
              (x) => x.name === 'FDV' && x.checked === true
            );
            var Vehicles = this.businessFeature.filter(
              (x) => x.name === 'Vehicles' && x.checked === true
            );
            var FoodSafety = this.businessFeature.filter(
              (x) => x.name === 'FoodSafety' && x.checked === true
            );
            var KubaControl = this.businessFeature.filter(
              (x) => x.name === 'KubaControl' && x.checked === true
            );
            var Framework = this.businessFeature.filter(
              (x) => x.name === 'Framework Agreement' && x.checked === true
            );
            var Service = this.businessFeature.filter(
              (x) => x.name === 'Service Agreement' && x.checked === true
            );
            var Kunde = this.businessFeature.filter(
              (x) => x.name === 'Kunde EL' && x.checked === true
            );
            if (internal.length > 0) {
              this.isInternalControl = true;
            }
            if (project.length > 0) {
              this.isproject = true;
            }
            if (othersystem.length > 0) {
              this.isothersystem = true;
            }
            if (qualitysystem.length > 0) {
              this.isqualitysystem = true;
            }
            if (fdv.length > 0) {
              this.isfdv = true;
            }
            if (Vehicles.length > 0) {
              this.isVehicles = true;
            }
            if (FoodSafety.length > 0) {
              this.isFoodSafety = true;
            }
            if (KubaControl.length > 0) {
              this.isKubaControl = true;
            }
            if (Framework.length > 0) {
              this.isFramework = true;
            }
            if (Service.length > 0) {
              this.isService = true;
            }
            if (Kunde.length > 0) {
              this.isKunde = true;
            }
          }
        })
      );
    }
    else {
      let featuresBaseDetails = FeaturesBaseServices.getFeatureDetails(
        BaseServices.getUserFeatures()
      );
      var internal = featuresBaseDetails.filter(
        (x) => x.name === 'Internalcontrol' && x.checked === true
      );
      var project = featuresBaseDetails.filter(
        (x) => x.name === 'Project' && x.checked === true
      );
      var othersystem = featuresBaseDetails.filter(
        (x) => x.name === 'OtherSystems' && x.checked === true
      );
      var qualitysystem = featuresBaseDetails.filter(
        (x) => x.name === 'QualitySystem' && x.checked === true
      );
      var fdv = featuresBaseDetails.filter(
        (x) => x.name === 'FDV' && x.checked === true
      );
      var Vehicles = featuresBaseDetails.filter(
        (x) => x.name === 'Vehicles' && x.checked === true
      );
      var FoodSafety = featuresBaseDetails.filter(
        (x) => x.name === 'FoodSafety' && x.checked === true
      );
      var KubaControl = featuresBaseDetails.filter(
        (x) => x.name === 'KubaControl' && x.checked === true
      );
      var Framework = featuresBaseDetails.filter(
        (x) => x.name === 'Framework Agreement' && x.checked === true
      );
      var Service = featuresBaseDetails.filter(
        (x) => x.name === 'Service Agreement' && x.checked === true
      );
      var Kunde = featuresBaseDetails.filter(
        (x) => x.name === 'Kunde EL' && x.checked === true
      );
      if (internal.length > 0) {
        this.isInternalControl = true;
      }
      if (project.length > 0) {
        this.isproject = true;
      }
      if (othersystem.length > 0) {
        this.isothersystem = true;
      }
      if (qualitysystem.length > 0) {
        this.isqualitysystem = true;
      }
      if (fdv.length > 0) {
        this.isfdv = true;
      }
      if (Vehicles.length > 0) {
        this.isVehicles = true;
      }
      if (FoodSafety.length > 0) {
        this.isFoodSafety = true;
      }
      if (KubaControl.length > 0) {
        this.isKubaControl = true;
      }
      if (Framework.length > 0) {
        this.isFramework = true;
      }
      if (Service.length > 0) {
        this.isService = true;
      }
      if (Kunde.length > 0) {
        this.isKunde = true;
      }
    }

    // To hide side menu bar
    document.querySelector('body').classList.remove('opened');
    this.bindDepartmentDropdown();
    this.subscriptions.push(
      this.translate.stream('RISKFIGURE_DROPDOWN').subscribe((val) => {
        this.importances = [];
        this.importances.push(
          { label: val.SELECT, value: null },
          { label: val.LOW, value: 'Low' },
          { label: val.MEDIUM, value: 'Medium' },
          { label: val.HIGH, value: 'High' }
        );
      })
    );
    if (BaseServices.UserRole === 'Admin') {
      this.isShowPlusbutton = false;
    }
    if (+BaseServices.roleId === 2) {
      this.isShowPlusbutton = false;
    }
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.ADMINISTRATE_DEVIATION;
    if (+BaseServices.roleId === 5) {
      this.isShowPlusbutton = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
    }

    this.vresperson = [];
    let responsiblePerson: any[];
    if (this.isAdmin == true) {
      responsiblePerson = this.route.snapshot.data['deviationuser'];
    } else {
      responsiblePerson = this.route.snapshot.data['user'];
    }

    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
        this.vresperson = [];
        this.vresperson.push({ label: val.SELECT, value: null });
        if (responsiblePerson) {
          responsiblePerson.forEach((responblePerson: any) => {
            this.vresperson.push({
              label: responblePerson.Name,
              value: responblePerson.Id,
            });
          });
        }
      })
    );

    if (BaseServices.roleId === '3') {
      this.isBusinessId = true;
      this.bindCreatedByDropDown(BaseServices.BusinessId);
    }

    this.vDepartment = [];
    let departments: any[];
    departments = this.route.snapshot.data['departments'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
        this.vDepartment = [];
        this.vDepartment.push({ label: val.SELECT, value: null });
      })
    );
    if (departments) {
      departments.forEach((department: any) => {
        this.vDepartment.push({
          label: department.Name,
          value: department.Id,
        });
      });
    }
    this.subscriptions.push(
      this.translate.stream('RISKFIGURE_DROPDOWN').subscribe((val) => {
        this.importances = [];
        this.importances.push(
          { label: val.SELECT, value: null },
          { label: val.LOW, value: 'Low' },
          { label: val.MEDIUM, value: 'Medium' },
          { label: val.HIGH, value: 'High' }
        );
      })
    );
    if (this.isPortal || this.isAdmin && BaseServices.ApplicationId != 4) {
      this.translate.stream('VMODULES').subscribe((val) => {
        this.vModules = [];
        this.vModules.push(
          { label: val.SELECT, value: null },
          { label: val.KUBA_Control, value: 'KUBA_Control' },
          { label: val.FDV, value: 'FDV' },
          { label: val.FOLLOW_UP, value: 'Follow up' },
          { label: val.FOOD_SAFETY, value: 'FOOD_SAFETY' },
          { label: val.INTERNAL_CONTROL, value: 'INTERNAL_CONTROL' },
          { label: val.OTHER_SYSTEMS, value: 'OTHER_SYSTEMS' },
          { label: val.PROJECT, value: 'PROJECT' },
          { label: val.QUALITY_SYSTEMS, value: 'QUALITY_SYSTEMS' },
          { label: val.Vehicle, value: 'Vehicle' }
        );
      });
    } else {
      if (BaseServices.ApplicationId != 4) {
        this.isIKdeviation = true;
        this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
          this.vModules = [];
          this.vModules.push({ label: val.SELECT, value: null });

          // If in R mode, use the features from appSettings
          if (sessionStorage.getItem('RModeBusiness')) {
            const businessId: number | null = sessionStorage.getItem(
              'RModeBusinessId'
            )
              ? Number(sessionStorage.getItem('RModeBusinessId'))
              : null;

            if (businessId !== null) {
              this.deviationService
                .getFeatureByBusiness(businessId)
                .subscribe((deviationlist: string) => {
                  if (deviationlist) {
                    this.features = JSON.parse(
                      deviationlist
                    ) as SessionFeature[];
                    this.assignModulesWithApiData();
                  }
                });
            }
          } else {
            this.features = BaseServices.userFeatures;
            this.assignModulesWithApiData();
          }
        });
      } else if (BaseServices.ApplicationId == 4) {
        this.isAHdeviation = true;
        this.translate.stream('VMODULES').subscribe((val) => {
          this.vModules = [];
          this.vModules.push(
            { label: val.SELECT, value: null },
            { label: 'EL', value: 'EL (' },
            { label: 'FA', value: 'FA (' },
            { label: 'FDV', value: 'FDV' },
            { label: 'Follow up', value: 'Follow up' },
            { label: 'IK', value: 'IK (' },
            { label: 'PR', value: 'PR (' },
            { label: 'SA', value: 'SA (' },
            { label: 'KJ', value: 'KJ (' }
          );
        });
      } else {
        this.translate.stream('VMODULES').subscribe((val) => {
          this.vModules = [];
          this.vModules.push(
            { label: val.SELECT, value: null },
            { label: val.KUNDE_EL, value: 'KUNDE_EL' },
            { label: val.FRAMEWORK_AGREEMENT, value: 'FRAMEWORK_AGREEMENT' },
            { label: val.FDV, value: 'FDV' },
            { label: val.FOLLOW_UP, value: 'Follow up' },
            { label: val.INTERNAL_CONTROL, value: 'INTERNAL_CONTROL' },
            { label: val.PROJECT, value: 'PROJECT' },
            { label: val.SERVICE_AGREEMENT, value: 'SERVICE_AGREEMENT' },
            { label: val.Vehicle, value: 'Vehicle' }
          );
        });
      }
    }
    this.startChartCycling();
  }

  //#region sorting methods

  /**
   * Handle sort events from p-table
   * @param event Sort event from PrimeNG table
   */
  onSort(event: any): void {
    if (this.isLoadingData) return;

    const sortField = event.field;
    const sortOrder = event.order; // 1 for ASC, -1 for DESC

    // Map UI column name to stored procedure parameter name
    const mappedColumn = this.columnMapping[sortField];

    if (mappedColumn) {
      this.paginationRequest.sortColumn = mappedColumn;
      this.paginationRequest.sortDirection = sortOrder === 1 ? 'ASC' : 'DESC';

      this.validateSorting();

      this.paginationRequest.pageNumber = 1;

      this.bindDeviationList(false);
    }
  }

  /**
   * Validates and cleans the sorting parameters
   */
  private validateSorting(): void {
    const validSortColumns = ['No', 'BusinessName', 'Title', 'CreatedOn', 'DoneOn'];

    if (this.paginationRequest.sortColumn && !validSortColumns.includes(this.paginationRequest.sortColumn)) {
      this.paginationRequest.sortColumn = undefined;
    }

    if (this.paginationRequest.sortDirection && !['ASC', 'DESC'].includes(this.paginationRequest.sortDirection)) {
      this.paginationRequest.sortDirection = 'ASC';
    }
  }

  /**
   * Clear sorting and reset to default
   */
  clearSorting(): void {
    if (this.paginationRequest) {
      this.paginationRequest.sortColumn = undefined;
      this.paginationRequest.sortDirection = 'ASC';
      this.paginationRequest.pageNumber = 1;

      // Reset table sorting UI
      if (this.deviationTable) {
        this.deviationTable.sortField = undefined;
        this.deviationTable.sortOrder = 1;
      }

      this.bindDeviationList(false);
    }
  }

  /**
   * Get current sort information for display
   */
  getCurrentSortInfo(): string {
    if (!this.paginationRequest.sortColumn) {
      return '';
    }

    return `${this.paginationRequest.sortColumn} (${this.paginationRequest.sortDirection})`;
  }

  //#endregion

  assignModulesWithApiData() {
    this.subscriptions.push(
      this.deviationService.getModulesByDeviation().subscribe(
        (apiModules: string[]) => {
          const excludedKeys = [
            'OUR_COMPANY',
            'DASHBOARD',
            'MY_PAGE',
            'EMPLOYEES',
            'CONTACTS',
            'CLIENT',
            'SUB_CONTRACTOR',
            'MANUALS',
            'SUPPLIERS',
            'INTERNAL_NEWS',
            'FLEXI',
            'ARCHIVE',
          ];

          const addedValues = new Set();

          this.features.forEach((feature) => {
            if (
              feature.checked &&
              !excludedKeys.includes(feature.translationKey) &&
              !addedValues.has(feature.translationKey)
            ) {
              this.translate
                .get(feature.translationKey)
                .subscribe((translatedLabel) => {
                  this.vModules.push({
                    label: translatedLabel,
                    value: feature.name,
                  });
                  addedValues.add(feature.translationKey);
                });
            }
          });

          if (apiModules && apiModules.length > 0) {
            apiModules.forEach((module: string) => {
              const existingModule = this.vModules.find(m => m.value === module);
              if (!existingModule) {
                this.vModules.push({
                  label: module,
                  value: module
                });
              }
            });
          }
        },
        (error) => {
          console.error('Error fetching modules from API:', error);
          this.assignModules();
        }
      )
    );
  }

  assignModules() {
    const excludedKeys = [
      'OUR_COMPANY',
      'DASHBOARD',
      'MY_PAGE',
      'EMPLOYEES',
      'CONTACTS',
      'CLIENT',
      'SUB_CONTRACTOR',
      'MANUALS',
      'SUPPLIERS',
      'INTERNAL_NEWS',
      'FLEXI',
      'ARCHIVE',
    ];
    const addedValues = new Set();
    this.features.forEach((feature) => {
      if (
        feature.checked &&
        !excludedKeys.includes(feature.translationKey) &&
        !addedValues.has(feature.translationKey)
      ) {
        this.translate
          .get(feature.translationKey)
          .subscribe((translatedLabel) => {
            this.vModules.push({
              label: translatedLabel,
              value: feature.name,
            });
            addedValues.add(feature.translationKey);
          });
      }
    });
  }
  bindCreatedByDropDown(businessId: number) {
    this.createdBy = [];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
        this.createdBy = [];
        this.createdBy.push({ label: val.SELECT, value: null });
        this.subscriptions.push(
          this.deviationService.getUser(businessId).subscribe((list: any) => {
            if (list) {
              list.forEach((element: any) => {
                this.createdBy.push({
                  label: element.Name,
                  value: element.ContactPersonId,
                });
              });
            }
          })
        );
      })
    );
  }
  /**
   * bind the department dropdown list
   */
  bindDepartmentDropdown() {
    this.departments = [];
    let roleId = BaseServices.roleId;
    if (roleId === '1' || roleId === '2') {
      this.departmentList = this.route.snapshot.data['departmentPortal'];
    } else {
      this.departmentList = this.route.snapshot.data['department'];
    }
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
        this.departments = [];
        this.departments.push({ label: val.SELECT, value: null });
        if (this.departmentList) {
          this.departmentList.forEach((department: any) => {
            this.departments.push({
              label: department.Name,
              value: department.Id,
            });
            this.departmentIds.push(department.Id);
          });
        }
      })
    );
  }
  /**
   * bind the sub department dropdown list
   */
  bindSubDepartmentDropdown(value: number[]) {
    const roleId = BaseServices.roleId;
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
        this.subDepartments = [];
        this.subDepartments.push({ label: val.SELECT, value: null });
        this.employeeServices
          .getSubDepartments(value, BaseServices.BusinessId, roleId)
          .subscribe((subDepartment: any) => {
            subDepartment.forEach((element: any) => {
              if (subDepartment) {
                this.subDepartments.push({
                  label: element.Name,
                  value: element.Id,
                });
              }
            });
          });
      })
    );
  }
  //#endregion

  /**
   * Filter follow up persons for autocomplete
   */
  filterFollowUpPersons(event: any) {
    const query = event.query;
    this.filteredFollowUpPersons = this.followup.filter(person =>
      person.label && person.label.toLowerCase().includes(query.toLowerCase())
    );
  }

  /**
   * Filter execution persons for autocomplete
   */
  filterExecutionPersons(event: any) {
    const query = event.query;
    this.filteredExecutionPersons = this.vresperson.filter(person =>
      person.label && person.label.toLowerCase().includes(query.toLowerCase())
    );
  }

  //#region page-destroy-event

  ngOnDestroy() {
    document.querySelector('body').classList.add('opened');

    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }

    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }


  //#endregion


  /**
   *  filter list based on Type of case
   * @param e  {any}
   * @param topicDropdown  {any}
   */
  onTopicChanged(topicDropdown: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = topicDropdown?.value;
    const selectedLabel = topicDropdown?.selectedOption?.label;

    sessionStorage.setItem('search_FollowupDev_TypeOfCase', selectedLabel || '');

    this.selectedFilters.topic = selectedLabel !== 'Select' ? selectedLabel : null;
    this.deviationFilterDto.topicId = selectedValue && selectedValue !== 'Select' ? selectedValue : undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }

  /**
   *  filter list based on Type of case
   * @param e  {any}
   * @param caseDropdown  {any}
   */
  onCaseChanged(caseDropdown: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = caseDropdown?.value;
    const selectedLabel = caseDropdown?.selectedOption?.label;

    sessionStorage.setItem(
      'search_FollowupDev_TypeOfCase',
      selectedLabel || ''
    );

    this.selectedFilters.case =
      selectedLabel !== 'Select' ? selectedLabel : null;

    this.deviationFilterDto.caseId = selectedValue && selectedValue !== 'Select' ? selectedValue : undefined;

    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList(false);
  }

  /**
   * custom filter datatable of status
   */
  onStatusChanged(event: any, statusDropdown?: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = event?.value !== undefined ? event.value : event;

    this.deviationFilterDto.status = selectedValue || undefined;
    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }

  onModuleChange(e: DropdownEvent) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = e.value;

    this.deviationFilterDto.modules = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }

  /**
   * Handle follow up person selection from autocomplete
   */
  onFollowupSelected(selectedPerson: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = selectedPerson?.value || null;

    sessionStorage.setItem(
      'search_FollowupDev_ResponsibleForFollowup',
      selectedValue || ''
    );

    this.selectedFilters.followUp = selectedValue;
    this.deviationFilterDto.followUpUserId = selectedValue || undefined;
    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList();
  }

  /**
   * Handle execution person selection from autocomplete
   */
  onExecutionSelected(selectedPerson: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = selectedPerson?.value || null;

    sessionStorage.setItem(
      'search_FollowupDev_ResponsibleForExecution',
      selectedValue || ''
    );

    this.selectedFilters.execution = selectedValue;
    this.deviationFilterDto.executionUserId = selectedValue || undefined;
    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList();
  }

  onImportanceChange(e: any, importanceControl: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = e.value;

    this.deviationFilterDto.importance = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }

  /**
   *  filter list based on Client
   * @param e {any}
   * @param clientDropdown {any}
   */
  onClientChanged(clientDropdown: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = clientDropdown?.value;

    sessionStorage.setItem('search_FollowupDev_Client', selectedValue || '');

    this.deviationFilterDto.clientId = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }
  /**
   * filter deviation list based on show devaition value
   * @param e {any}
   * @param showDeviationDropdown {any}
   */
  onShowDeviationChanged(e: any) {
    const selectedValue = e.value;
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT;
    this.isShowDeptDeviation = BaseServices.checkUserRights(
      userRightsId,
      currentUserRole
    );

    if (selectedValue === '1') {
      this.currentDeviation = 1;

      this.deviationFilterDto = {};

      this.paginationRequest.pageNumber = 1;

      this.bindDeviationList();
    } else if (selectedValue === '2') {
      this.currentDeviation = 2;

      this.deviationFilterDto = {
        myOwnDeviation: true,
        userId: BaseServices.UserId
      };

      this.paginationRequest.pageNumber = 1;

      this.bindDeviationList();
    }
  }
  /**
   * save and updating topic
   */
  saveTopic() {
    this.loading = true;
    let reskTopic = new Topic();
    reskTopic.Id = this.topicId ? this.topicId : 0;
    reskTopic.Name = this.topicForm.value.Topic;
    reskTopic.Status = '1';
    reskTopic.BusinessId = BaseServices.BusinessId;
    if (reskTopic.Id > 0) {
      this.subscriptions.push(
        this.deviationService
          .updateTopics(reskTopic)
          .subscribe((isTopicUpdated) => {
            if (isTopicUpdated) {
              this.toasterComponent.callToast();
              this.loading = false;
              this.bindTopicDropdown();
              this.deviationSearch.get('topic')!.patchValue(isTopicUpdated.Id);
            } else {
              this.existsTopicAlerttext = this.translate.instant(`TOPIC_EXIST`);
              this.isTopicNameExists = true;
              this.loading = false;
              setTimeout(() => {
                this.isTopicNameExists = false;
              }, 3000);
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.deviationService.addTopics(reskTopic).subscribe((isTopicAdded) => {
          if (isTopicAdded) {
            this.toasterComponent.callToast();
            this.loading = false;
            this.bindTopicDropdown();
            this.riskanalysisService.clearCachedTopic();
            this.deviationSearch.get('topic')!.patchValue(isTopicAdded.Id);
          } else {
            this.existsTopicAlerttext = this.translate.instant(`TOPIC_EXIST`);
            this.isTopicNameExists = true;
            this.loading = false;
            setTimeout(() => {
              this.isTopicNameExists = false;
            }, 3000);
          }
        })
      );
    }
    this.clear();
  }
  clear() {
    this.topicId = 0;
    this.topicForm = this._fb.group({
      Topic: '',
    });
  }
  /**
   * save type of case
   */
  saveTypeOfCase() {
    this.loading = true;
    let typeOfcase = new TypeOfCase();
    typeOfcase.Id = this.caseId ? this.caseId : 0;
    typeOfcase.Name = this.caseForm.value.Case;
    typeOfcase.Status = '1';
    typeOfcase.BusinessId = BaseServices.BusinessId;
    typeOfcase.ApplicationId = BaseServices.ApplicationId;
    if (typeOfcase.Id > 0) {
      typeOfcase.ModifiedBy = BaseServices.UserId;
      this.subscriptions.push(
        this.deviationService
          .updateCaseType(typeOfcase.Id, typeOfcase)
          .subscribe((isCaseUpdated) => {
            if (isCaseUpdated) {
              this.addtypeOfCase = false;
              this.bindTypeofCaseDropdown();
              this.deviationSearch
                .get('typeOfCase')!
                .patchValue(isCaseUpdated.Id);
              this.toasterComponent.callToast();
              this.loading = false;
            } else {
              this.existsTypeCaseAlerttext =
                this.translate.instant(`TOPIC_EXIST`);
              this.isTypeCaseNameExists = true;
              this.loading = false;
              setTimeout(() => {
                this.isTypeCaseNameExists = false;
              }, 3000);
            }
          })
      );
    } else {
      typeOfcase.CreatedBy = BaseServices.UserId;
      this.subscriptions.push(
        this.deviationService
          .addTypeCase(typeOfcase)
          .subscribe((isCaseAdded) => {
            if (isCaseAdded) {
              this.addtypeOfCase = false;
              this.deviationService.clearCachedCaseType();
              this.deviationSearch
                .get('typeOfCase')!
                .patchValue(isCaseAdded.Id);
              this.bindTypeofCaseDropdown();
              this.toasterComponent.callToast();
              this.loading = false;
            } else {
              this.existsTypeCaseAlerttext =
                this.translate.instant(`TOPIC_EXIST`);
              this.isTypeCaseNameExists = true;
              this.loading = false;
              setTimeout(() => {
                this.isTypeCaseNameExists = false;
              }, 3000);
            }
          })
      );
    }
    this.clearCaseForm();
  }
  clearCaseForm() {
    this.caseId = 0;
    this.caseForm = this._fb.group({
      Case: '',
    });
  }
  /**
   * startdate calendar onselect event
   * @param event {any}
   */
  onStartDateChanged(event: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    if (event.jsdate) {
      const date = new Date(event.jsdate);
      date.setHours(0, 0, 0, 0);
      this.deviationFilterDto.createdFrom = date.toISOString();

      sessionStorage.setItem('search_FollowupDev_CreatedFrom', event.jsdate.toString());
    } else {
      this.deviationFilterDto.createdFrom = undefined;
      sessionStorage.removeItem('search_FollowupDev_CreatedFrom');
    }

    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList(false);
  }

  /**
   * enddate calendar onselect event
   * @param event {any}
   */
  onEndDateChanged(event: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    if (event.jsdate) {
      const date = new Date(event.jsdate);
      date.setHours(23, 59, 59, 999);
      this.deviationFilterDto.createdTo = date.toISOString();

      // this.endDate = event.formatted;

      sessionStorage.setItem('search_FollowupDev_CreatedTo', event.jsdate.toString());
    } else {
      this.deviationFilterDto.createdTo = undefined;
      sessionStorage.removeItem('search_FollowupDev_CreatedTo');
    }

    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList(false);
  }


  /**
   * edit topic
   * @param Topictype {any}
   */
  editTopicType(topic: Topic) {
    this.topicId = topic.Id!;
    let result = {
      Topic: topic.Name,
    };
    (<FormGroup>this.topicForm).setValue(result, { onlySelf: true });
  }
  /**
   * delete topic
   * @param id {any}
   */
  deleteTopic(id: any) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.deviationService.deleteTopics(id).subscribe((isTopicDeleted) => {
            if (isTopicDeleted) {
              this.riskanalysisService.clearCachedTopic();
              this.bindTopicDropdown();
            }
          })
        );
      },
    });
  }
  /**
   * edit type of case
   * @param TypeOfCase {any}
   */
  editTypeOfCase(typeOfCase: TypeOfCase) {
    this.caseId = typeOfCase.Id!;
    let result = {
      Case: typeOfCase.Name,
    };
    (<FormGroup>this.caseForm).setValue(result, { onlySelf: true });
  }
  /**
   * delete type of case
   * @param deleteType {any}
   */
  deleteTypeOfCase(deleteType: any) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.deviationService
            .deleteTypeCase(deleteType)
            .subscribe((isCaseDeleted) => {
              if (isCaseDeleted) {
                this.deviationService.clearCachedCaseType();
                this.bindTypeofCaseDropdown();
              }
            })
        );
      },
    });
  }

  /**
   * Handle follow up autocomplete clear
   */
  onFollowupCleared() {
    this.selectedFollowUpPerson = null;
    this.onFollowupSelected(null);
  }

  /**
   * Handle execution autocomplete clear
   */
  onExecutionCleared() {
    this.selectedExecutionPerson = null;
    this.onExecutionSelected(null);
  }

  onStatusCleared() {
    this.onStatusChanged(null);
  }

  /**
   * fetches data and refreshes grid
   */
  clearFilters() {
    if (this.isLoadingData) return;

    sessionStorage.removeItem('search_FollowupDev_Dept');
    sessionStorage.removeItem('search_FollowupDev_Client');
    sessionStorage.removeItem('search_FollowupDev_CreatedTo');
    sessionStorage.removeItem('search_FollowupDev_CreatedFrom');
    sessionStorage.removeItem('search_FollowupDev_Topics');
    sessionStorage.removeItem('search_FollowupDev_Desc');
    sessionStorage.removeItem('search_FollowupDev_TypeOfCase');
    sessionStorage.removeItem('search_FollowupDev_ResponsibleForFollowup');
    sessionStorage.removeItem('search_FollowupDev_ResponsibleForExecution');
    sessionStorage.removeItem('search_FollowupDev_CreatedBy');

    this.deptFilter = null;
    this.clientFilter = null;
    this.createdToFilter = null;
    this.craetedFromFilter = null;
    this.deviationSearch.reset();
    this.descFilter = null;
    this.responsibleFollowUpFilter = null;
    this.responsibleExecutionFilter = null;
    this.createdByFilter = null;
    this.selectedFollowUpPerson = null;
    this.selectedExecutionPerson = null;
    this.filteredFollowUpPersons = [];
    this.filteredExecutionPersons = [];

    this.deviationFilterDto = {};

    this.paginationRequest.pageNumber = 1;

    // Clear sorting as well
    this.clearSorting();

    if (this.deviationTable) {
      this.deviationTable.reset();
    }

    this.bindDeviationList(false);
  }


  /**
   * topic popup reset
   */
  onBeforeDeviationTopicDialogHide() {
    this.topicForm.reset();
  }

  /**
   * type of case popup reset
   */
  onBeforeDeviationTypeofCaseDialogHide() {
    this.caseForm.reset();
  }

  //#endregion

  //#region methods
  /**
   * bind deviation list by User Id
   */
  bindDeviationByUser() {
    if (
      BaseServices.UserRole == 'User' ||
      BaseServices.UserRole == 'Guest' ||
      BaseServices.UserRole == 'Editor'
    ) {
      this.deviationList = [];
      this.showLoader = true;

      this.subscriptions.push(
        this.deviationService
          .getDeviationsByUserPaged(
            BaseServices.UserId,
            this.paginationRequest,
            this.deviationFilterDto
          )
          .subscribe((response: PagedResponse<DeviationListDto>) => {
            this.handleDeviationResponse(response);
          })
      );
    }
  }
  /**
   *
   * bind status icon by status
   * @param deviations {any}
   */
  bindStatusIcon(deviations: any) {
    this.deviationList = [];
    if (deviations) {
      deviations.forEach((deviationInfo: any) => {
        let daysDiff = 0;
        let statusIcon = '';
        let currentdate = new Date();
        let deadLine = new Date(deviationInfo.Deadline);
        deviationInfo.Importance = this.assignRiskData(
          deviationInfo.Importance
        );
        if (deviationInfo.Deadline != null) {
          daysDiff = HelperService.getDaysDiff(currentdate, deadLine);
        }
        if (deviationInfo.StatusId === 9) {
          statusIcon = 'icon ic-sm icon-clear-deadline';
        } else if (deviationInfo.StatusId === 10) {
          statusIcon = 'icon ic-sm icon-cancel';
        } else if (deviationInfo.StatusId === 7) {
          statusIcon = 'icon ic-sm icon-new-deadline';
        } else if (deviationInfo.Deadline) {
          if (daysDiff > 3) {
            statusIcon = 'icon ic-sm icon-far-deadline';
          } else if (daysDiff > -1 && daysDiff < 4) {
            statusIcon = 'icon ic-sm icon-near-deadline';
          } else {
            statusIcon = 'icon ic-sm icon-over-deadline';
          }
        } else {
          statusIcon = 'icon ic-sm icon-over-deadline';
        }
        if (
          +deviationInfo.ClientId === FeatureKey.FOOD_SAFETY &&
          sessionStorage.getItem('languageId') === '2'
        ) {
          deviationInfo.Modules = deviationInfo.Modules.replace('FS', 'IK-Mat');
        }
        deviationInfo.StatusIcon = statusIcon;
        this.deviationList.push(deviationInfo);
        this.rowsPerPageOptions = [10, 20, 50, 100];
        if (this.totalRecords > 100) {
          this.rowsPerPageOptions.push(this.totalRecords);
        }
      });
    }
  }

  bindDeviationList(showInitialLoader: boolean = false) {
    if (showInitialLoader) {
      this.showLoader = true;
    }

    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const applicationId = BaseServices.ApplicationId || 0;
    const userId = BaseServices.UserId || 0;
    const isPortalManager = BaseServices.PortalManager || false;
    const businessId = BaseServices.BusinessId || 0;
    const portalId = BaseServices.PortalId || 0;
    this.portalId = portalId;

    this.validateSorting();

    let dataObservable: Observable<PagedResponse<DeviationListDto>>;

    if (this.isAdmin) {
      dataObservable = this.deviationService.getDeviationListPagedAdmin(
        this.paginationRequest,
        this.deviationFilterDto
      );
    } else if (this.isPortal) {
      dataObservable = this.deviationService.portalDeviationPagedList(
        portalId,
        userId,
        isPortalManager,
        applicationId,
        this.paginationRequest,
        this.deviationFilterDto
      );
    } else {
      dataObservable = this.deviationService.getDeviationListPagedByBusinessId(
        applicationId,
        this.paginationRequest,
        businessId,
        this.deviationFilterDto
      );
    }

    this.isLoadingData = true;

    this.loadingSubscription = dataObservable.subscribe(
      (response: PagedResponse<DeviationListDto>) => {
        this.handleDeviationResponse(response);
        this.isLoadingData = false;
        if (showInitialLoader) {
          this.showLoader = false;
        }
      },
      (error) => {
        console.error('Error fetching deviations:', error);
        this.isLoadingData = false;
        if (showInitialLoader) {
          this.showLoader = false;
        }
      }
    );
  }

  private applyStatusIconsToList(deviations: any[]) {
    if (deviations) {
      deviations.forEach((deviationInfo: any) => {
        let daysDiff = 0;
        let statusIcon = '';
        let currentdate = new Date();
        let deadLine = new Date(deviationInfo.Deadline);

        deviationInfo.Importance = this.assignRiskData(deviationInfo.Importance);

        if (deviationInfo.Deadline != null) {
          daysDiff = HelperService.getDaysDiff(currentdate, deadLine);
        }

        if (deviationInfo.StatusId === 9) {
          statusIcon = 'icon ic-sm icon-clear-deadline';
        } else if (deviationInfo.StatusId === 10) {
          statusIcon = 'icon ic-sm icon-cancel';
        } else if (deviationInfo.StatusId === 7) {
          statusIcon = 'icon ic-sm icon-new-deadline';
        } else if (deviationInfo.Deadline) {
          if (daysDiff > 3) {
            statusIcon = 'icon ic-sm icon-far-deadline';
          } else if (daysDiff > -1 && daysDiff < 4) {
            statusIcon = 'icon ic-sm icon-near-deadline';
          } else {
            statusIcon = 'icon ic-sm icon-over-deadline';
          }
        } else {
          statusIcon = 'icon ic-sm icon-over-deadline';
        }

        if (+deviationInfo.ClientId === FeatureKey.FOOD_SAFETY &&
          sessionStorage.getItem('languageId') === '2') {
          deviationInfo.Modules = deviationInfo.Modules.replace('FS', 'IK-Mat');
        }

        deviationInfo.StatusIcon = statusIcon;
      });
    }
  }

  /**
   * Handle the response from the deviation service
   */
  private handleDeviationResponse(response: PagedResponse<DeviationListDto>) {
    if (response != null && response.Succeeded) {
      const processedList: DeviationListDto[] = response.Items;

      this.applyStatusIconsToList(processedList);

      this.deviationList = processedList;
      this.totalRecords = response.TotalCount;
      this.totalPages = response.TotalPages;
      this.paginationRequest.pageNumber = response.PageNumber;
      this.paginationRequest.pageSize = response.PageSize;

      if (Boolean(response.Metadata)) {
        this.deviationListMetadata = response.Metadata;
      } else {
        this.deviationListMetadata = null;
        console.warn('Deviation list metadata not found in the API response.');
      }
      this.bindDropDowns(this.deviationList)


      if (this.deviationTable) {
        const firstIndex =
          (this.paginationRequest.pageNumber - 1) *
          this.paginationRequest.pageSize;
        this.deviationTable.first = firstIndex;
      } else {
        return;
      }
    }
  }


  /**
   * color risk figure
   * @param riskFigure {any}
   */
  assignRiskData(riskFigure: any) {
    let riskData: any = [];
    if (riskFigure!.value) {
      return riskFigure;
    } else {
      if (riskFigure === 'Low') {
        riskData.id = 1;
        riskData.value = 'LOW';
        riskData.backColor = '#4ec55c';
      } else if (riskFigure === 'Medium') {
        riskData.id = 2;
        riskData.value = 'MEDIUM';
        riskData.backColor = '#f0ac19';
      } else if (riskFigure === 'High') {
        riskData.id = 3;
        riskData.value = 'HIGH';
        riskData.backColor = '#e7644f';
      } else {
        riskData.backColor = '';
      }
      return riskData;
    }
  }


  /**
   * delete deviation
   * @param id {any}
   */
  confirm(id: any) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.deviationService.deleteDeviation(id);
        this.deviationList = this.deviationList.filter(
          (deviation: DeviationListDto) => deviation.Id !== id);
        this.toasterComponent.callToastDlt();
      },
    });
  }

  /**
   * bind dropdowns
   */
  bindDropDowns(deviations: any) {
    this.followup = [];
    let followUpPerson: any[];
    if (this.isAdmin == true) {
      followUpPerson = this.route.snapshot.data['deviationuser'];
    } else {
      followUpPerson = this.route.snapshot.data['user'];
    }
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
        this.followup = [];
        this.followup.push({ label: val.SELECT, value: null });
        if (followUpPerson) {
          followUpPerson.forEach((followupPerson: any) => {
            this.followup.push({
              label: followupPerson.Name,
              value: followupPerson.Id,
            });
          });
        }
      })
    );

    this.subscriptions.push(
      this.translate.stream('SELECT_STATUSES').subscribe((val) => {
        this.statuses = [];
        this.statuses.push(
          { label: val.SELECT, value: null },
          { label: val.NEW, value: 7 },
          { label: val.OPEN, value: 8 },
          { label: val.DONE, value: 9 },
          { label: val.REJECTED, value: 10 }
        );
      })
    );

    console.log('Statuses loaded:', this.statuses);

    this.Case = [];
    this.editTypeOfCases = [];
    let caseType: any[];
    caseType = this.route.snapshot.data['caseType'];
    const uniquecaseTypeSet = new Map<string, any>();

    caseType.forEach((item) => {

      const name = item.Name;

      if (!uniquecaseTypeSet.has(name)) {
        uniquecaseTypeSet.set(name, item);
      }
    });
    const uniquecaseType = Array.from(uniquecaseTypeSet.values());

    if (BaseServices.roleId != '2') {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
          this.Case = [];
          this.Case.push({ label: val.SELECT, value: null });
          if (caseType) {
            caseType.forEach((caseInfo: any) => {
              this.Case.push({ label: caseInfo.Name, value: caseInfo.Id });
              this.editTypeOfCases.push({
                Name: caseInfo.Name,
                Id: caseInfo.Id,
                IsDefault: caseInfo.IsDefault,
              });
            });
          }
        })
      );
    } else {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
          this.Case = [];
          this.Case.push({ label: val.SELECT, value: null });
          if (uniquecaseType) {
            uniquecaseType.forEach((caseInfo: any) => {
              this.Case.push({ label: caseInfo.Name, value: caseInfo.Id });
              this.editTypeOfCases.push({
                Name: caseInfo.Name,
                Id: caseInfo.Id,
                IsDefault: caseInfo.IsDefault,
              });
            });
          }
        })
      );
    }

    this.Client = [];
    let clients = this.route.snapshot.data['client'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
        this.Client = [];
        this.Client.push({ label: val.SELECT, value: null });
        if (clients) {
          clients.forEach((clientInfo: any) => {
            this.Client.push({
              label: clientInfo.Name,
              value: clientInfo.Id,
            });
          });
        }
      })
    );
    this.businesses = [];
    let business = this.route.snapshot.data['business'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
        this.businesses.push({ label: val.SELECT, value: null });
      })
    );
    if (business) {
      business.forEach((businessInfo: any) => {
        this.businesses.push({
          label: businessInfo.Name,
          value: businessInfo.Id,
        });
      });
    }

    this.Topics = [];
    this.editTopics = [];
    let topics: any[];

    topics = this.route.snapshot.data['topic'];
    const uniquecaseTopicSet = new Map<string, any>();

    if (!this.isAdmin) {
      topics.forEach((item) => {
        const name = item.Name;

        if (!uniquecaseTopicSet.has(name)) {
          uniquecaseTopicSet.set(name, item);
        }
      });
    }

    const uniquecaseTopic = Array.from(uniquecaseTopicSet.values());

    if (BaseServices.roleId != '2') {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
          this.Topics = [];
          this.Topics.push({ label: val.SELECT, value: null });
          if (topics) {
            topics.forEach((topicInfo: any) => {
              this.Topics.push({
                label: topicInfo.Name,
                value: topicInfo.Id,
              });
              this.editTopics.push({
                Name: topicInfo.Name,
                Id: topicInfo.Id,
              });
            });
          }
        })
      );
    } else {
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
          this.Topics = [];
          this.Topics.push({ label: val.SELECT, value: null });
          if (uniquecaseTopic) {
            uniquecaseTopic.forEach((topicInfo: any) => {
              this.Topics.push({
                label: topicInfo.Name,
                value: topicInfo.Id,
              });
              this.editTopics.push({
                Name: topicInfo.Name,
                Id: topicInfo.Id,
              });
            });
          }
        })
      );
    }


    this.subscriptions.push(
      this.translate.stream('SELECT_DEVIATIONDROP').subscribe((val) => {
        this.ShowDeviation = [];

        let userRightsId = Rights.ADMINISTRATE_DEVIATION;
        let role = BaseServices.UserRole;
        if (role === 'Editor') {
          this.ShowDeviation.push(
            { label: val.ALL_DEVIATION, value: '1' },
            { label: val.MY_DEVIATION, value: '2' }
          );
        } else if (role === 'User') {
          this.showDeviationDrop = BaseServices.checkUserRights(
            userRightsId,
            role
          );
          if (this.showDeviationDrop) {
            this.ShowDeviation.push(
              { label: val.ALL_DEVIATION, value: '1' },
              { label: val.MY_DEVIATION, value: '2' }
            );
          } else {
            let currentUserRole = BaseServices.UserRole;
            let userRightsId = Rights.VIEW_DEVIATION;
            let IsViewDeviation = BaseServices.checkUserRights(
              userRightsId,
              currentUserRole
            );
            let currentUserRole2 = BaseServices.UserRole;
            let userRightsId2 = Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT;
            let IsSeeOnlyDepartViewDev = BaseServices.checkUserRights(
              userRightsId2,
              currentUserRole2
            );
            if (IsViewDeviation) {
              this.ShowDeviation.push(
                { label: val.ALL_DEVIATION, value: '1' },
                { label: val.MY_DEVIATION, value: '2' }
              );
            } else if (IsSeeOnlyDepartViewDev) {
              this.ShowDeviation.push(
                { label: val.ALL_DEVIATION, value: '1' },
                { label: val.MY_DEVIATION, value: '2' }
              );
            } else {
              this.showDeviationDisabled = true;
              this.ShowDeviation.push({ label: val.MY_DEVIATION, value: '2' });
            }
          }
        } else {
          this.showDeviationDisabled = true;
          this.ShowDeviation.push({ label: val.MY_DEVIATION, value: '2' });
          this.bindDeviationByUser();
        }
      })
    );
    this.setDoneStatus(deviations);
  }

  setDoneStatus(deviations: any) {
    if (deviations) {
      deviations.forEach((e: any) => {
        if (e.StatusId === 9) {
          this.isStatusDone = false;
        } else {
          this.isStatusDone = true;
        }
      });
      this.deviationAllList = deviations;
      this.bindStatusIcon(deviations);
      this.getSum(deviations, 0, this.itemsPerPage);
    }
  }

  /**
   * bind type of case dropdown
   */
  bindTypeofCaseDropdown() {
    this.subscriptions.push(
      this.deviationService.getAllCaseType().subscribe((typeCaseList) => {
        if (typeCaseList) {
          this.Case = [];
          typeCaseList.forEach((typeCase: any) => {
            this.Case.push({ label: typeCase.Name, value: typeCase.Id });
          });
        }
        this.editTypeOfCases = typeCaseList;
      })
    );
  }

  /**
   * bind topic dropdown
   */
  bindTopicDropdown() {
    let topicList = this.route.snapshot.data['topic'];
    if (topicList) {
      this.Topics = [];
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe((val) => {
          this.Topics = [];
          this.Topics.push({ label: val.SELECT, value: null });
        })
      );
      topicList.forEach((topic: any) => {
        this.Topics.push({
          label: topic.Name,
          value: topic.Id,
        });
      });
      this.editTopics = topicList;
    };
  }

  deviationFilterChange(event: any) {
    let list = event.filteredValue;
    if (list && list.length > 0) {
      this.getSum(list, 0, this.itemsPerPage);
    }
  }

  onTextFilterChange(filterType: string, value: string) {
    if (this.isLoadingData) return;

    if (this.filterDebounceTimer) {
      clearTimeout(this.filterDebounceTimer);
    }

    this.filterDebounceTimer = setTimeout(() => {
      switch (filterType) {
        case 'no':
          this.noFilter = value;
          this.deviationFilterDto.no = value || undefined;
          break;
        case 'businessName':
          this.businessNameFilter = value;
          this.deviationFilterDto.businessName = value || undefined;
          break;
        case 'title':
          this.titleFilter = value;
          this.deviationFilterDto.title = value || undefined;
          break;
        case 'checklistName':
          this.checklistNameFilter = value;
          this.deviationFilterDto.checklistName = value || undefined;
          break;
        case 'activityName':
          this.activityNameFilter = value;
          this.deviationFilterDto.activityName = value || undefined;
          break;
      }

      this.paginationRequest.pageNumber = 1;

      this.bindDeviationList(false);
    }, 500);
  }

  deviationPageChange(event: any) {
    const newPageNumber = Math.floor(event.first / event.rows) + 1;
    const newPageSize = event.rows;

    if (this.paginationDebounceTimerId) {
      clearTimeout(this.paginationDebounceTimerId);
    }

    this.paginationDebounceTimerId = setTimeout(() => {
      this.paginationRequest.pageNumber = newPageNumber;
      this.paginationRequest.pageSize = newPageSize;

      // Preserve existing sorting when changing pages
      this.validateSorting();

      this.bindDeviationList(false);

      this.paginationDebounceTimerId = null;
    }, this.PAGINATION_DEBOUNCE_TIME_MS);
  }

  /**
   * page wise cost calculation
   * @param deviations {DeviationList}
   * @param start {number}
   * @param end {number}
   */
  getSum(deviations: DeviationList[], start: number, end: number): void {
    deviations = _.slice(deviations, start, end);
    let sum = _.sumBy(deviations, (o) => {
      return o.Cost || 0;
    });
    this.pageSum = this.convertDecimal(sum);
  }

  convertDecimal(data: any) {
    if (data !== null) {
      if (data === 0) {
        return data.toFixed(2);
      } else {
        return data.toFixed(2);
      }
    }
  }


  /**
   * Edit the page based upon administrate deviation rights
   */
  onAdministrateDeviation() {
    let currentUserRole1 = BaseServices.UserRole;
    let userRightsIdAdmin = Rights.ADMINISTRATE_DEVIATION;
    let userRightsView = Rights.VIEW_DEVIATION;
    let userRightsViewDepart = Rights.SEE_ONLY_DEVIATION_IN_OWN_DEPT;

    if (currentUserRole1 === 'User') {
      let CheckAdmin = BaseServices.checkUserRights(
        userRightsIdAdmin,
        currentUserRole1
      );
      let CheckView = BaseServices.checkUserRights(
        userRightsView,
        currentUserRole1
      );
      let CheckViewDepart = BaseServices.checkUserRights(
        userRightsViewDepart,
        currentUserRole1
      );

      if (!CheckAdmin && !CheckView && !CheckViewDepart) {
        this.bindDeviationByUser();
      }
    }

    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.ADMINISTRATE_DEVIATION;
    if (currentUserRole === 'User' || currentUserRole === 'Guest') {
      this.hasDeviationDeleteAccess = false;
      this.isStatusDone = false;
      this.isShowSaveButton = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
      if (this.isShowSaveButton === false) {
        this.displayDeviation = true;
        if (currentUserRole === 'Guest') {
          this.onDeviationRights();
        } else {
          this.newButtonDisplay = false;
        }
        this.onViewDeviation();
      } else if (this.isShowSaveButton) {
        this.hasDeviationDeleteAccess = true;
        this.bindDeviationList();
      }
    }
  }

  /**
   * update deviation based on viewdeviation rights
   */
  onViewDeviation() {
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.VIEW_DEVIATION;
    if (currentUserRole === 'User' || currentUserRole === 'Guest') {
      this.isShowSaveButton = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
      if (this.isShowSaveButton) {
        this.showDeviationDisabled = false;
        this.bindDeviationList();
      }
    }
  }

  /**
   * add deviation based on the deviation rights
   */
  onDeviationRights() {
    let userRightsId = Rights.DEVIATION_RIGHTS;
    let role = BaseServices.UserRole;
    if (role === 'Guest') {
      this.newButtonDisplay = BaseServices.checkUserRights(userRightsId, role);
      if (this.newButtonDisplay === true) {
        this.isShowNewButton = true;
      } else {
        this.isShowNewButton = false;
      }
    }
  }

  onCreatedByChange(e: any, searchValue: any) {
    const selectedValue = e.value;

    sessionStorage.setItem('search_FollowupDev_CreatedBy', selectedValue || '');

    this.deviationFilterDto.createdBy = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList();
  }

  /**
   * Show loading bar when export the data.
   */
  loader(value: any) {
    this.Showloader = value;
  }

  private startChartCycling() {
    setInterval(() => {
      if (!this.isPaused) {
        this.currentIndex = (this.currentIndex + 1) % this.chartViews.length;
        this.chartView = this.chartViews[this.currentIndex];
      }
    }, 8000);
  }

  togglePause() {
    this.isPaused = !this.isPaused;
  }

  changeChart(direction: 'next' | 'previous') {
    this.isPaused = true;

    if (direction === 'next') {
      this.currentIndex = (this.currentIndex + 1) % this.chartViews.length;
    } else if (direction === 'previous') {
      this.currentIndex =
        (this.currentIndex - 1 + this.chartViews.length) %
        this.chartViews.length;
    }
    this.chartView = this.chartViews[this.currentIndex];
  }

  onChildButtonClicked() {
    this.isPaused = true;
  }

  get chartView(): string {
    return this.chartViews[this.currentIndex];
  }

  set chartView(value: string) {
    this.currentIndex = this.chartViews.indexOf(value);
  }

  onFollowupChanged(followUpDropdown: Dropdown) {
    const selectedValue = followUpDropdown.value;

    sessionStorage.setItem(
      'search_FollowupDev_ResponsibleForFollowup',
      selectedValue || ''
    );

    this.selectedFilters.followUp = selectedValue;

    this.deviationFilterDto.followUpUserId = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList();
  }

  onExecutionChanged(executionDropdown: Dropdown) {
    const selectedValue = executionDropdown.selectedOption?.value || null;

    sessionStorage.setItem(
      'search_FollowupDev_ResponsibleForExecution',
      selectedValue || ''
    );

    this.selectedFilters.execution = selectedValue;

    this.deviationFilterDto.executionUserId = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList();
  }

  onDepartmentChangeId(e: any, departmentDropdown: any) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = e.value;
    this.deviationFilterDto.department = selectedValue || undefined;
    this.paginationRequest.pageNumber = 1;
    this.bindDeviationList(false);
  }

  onDepartmentChangedName(depControl: Dropdown) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }

    const selectedValue = depControl.value;
    const selectedLabel = depControl.label === 'Select' ? undefined : depControl.label;

    const departmentName = selectedValue && selectedLabel && selectedLabel !== 'Select'
      ? selectedLabel
      : undefined;

    sessionStorage.setItem('search_FollowupDev_Dept', selectedLabel || '');

    this.selectedFilters.department = departmentName;

    this.deviationFilterDto.department = departmentName;

    this.paginationRequest.pageNumber = 1;

    if (selectedValue) {
      this.bindSubDepartmentDropdown(selectedValue);
    } else {
      this.subDepartments = [];
      this.selectedFilters.subDepartment = null;
      this.deviationFilterDto.subDepartmentId = undefined;
    }

    this.bindDeviationList(false);

  }


  onSubDepartmentChanged(subDepControl: Dropdown) {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
      this.loadingSubscription = null;
    }
    const selectedValue = subDepControl.value;

    sessionStorage.setItem('search_FollowupDev_SubDept', selectedValue || '');

    this.selectedFilters.subDepartment = selectedValue || null;

    this.deviationFilterDto.subDepartmentId = selectedValue || undefined;

    this.paginationRequest.pageNumber = 1;

    this.bindDeviationList(false);
  }
}

//#endregion
